"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BORDER_RADIUS = void 0;
exports.toDisabledColor = toDisabledColor;
exports.toHoverColor = toHoverColor;
var _colors = require("../../core/colors");
var BORDER_RADIUS = exports.BORDER_RADIUS = Object.freeze({
  pill: '50px',
  rectangle: '0',
  rounded: '5px'
});
function toDisabledColor(color) {
  var withoutAlpha = color.substring(0, 7);
  return "".concat(withoutAlpha, "60");
}
function toHoverColor(color) {
  return (0, _colors.shadeColor)(color, -12);
}